<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="pe-7s-config icon-gradient bg-mean-fruit"></i>
        </div>
        <div>
          Admin Control
          <div class="page-title-subheading">Administrative settings for the HR portal.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3 card">
    <div class="card-body text-center text-muted py-5">Admin control features are coming soon.</div>
  </div>
</div>
